import React, { useState } from 'react';
import MarkdownText from '../MarkdownText/MarkdownText';
import { AssetProps } from '../../types';

interface ArticleKeyTakeawaysProps {
    keyTakeawaysContent?: {
        fields?: {
            className?: string;
            contentType?: string;
            description?: string;
            title?: string;
            id?: string;
            plusIcon?: {
                fields?: {
                    alternateText?: string;
                    asset?: AssetProps;
                };
            };
            minusIcon?: {
                fields?: {
                    alternateText?: string;
                    asset?: AssetProps;
                };
            };
        };
    };
    isMobile?: boolean;
}

const ArticleKeyTakeaways: React.FC<ArticleKeyTakeawaysProps> = ({ keyTakeawaysContent }) => {
    const { title, description } = keyTakeawaysContent?.fields || {};

    return (
        <div className='bg-revamp_bg w-full p-1h lg:p-2 lg:rounded-2xl' id={keyTakeawaysContent?.fields?.id}>
            <div className='flex items-center justify-center lg:justify-start'>
                {title && <h2 className='font-bold text-25 text-white leading-1/2 pr-2 pl-4 lg:pl-0'>{title}</h2>}
                </div>
            <div className='w-full'>
                <MarkdownText
                    className={'article-KeyTakeaways-description'}
                    value={description}
                />
            </div>
            
        </div>
    );
};

export default ArticleKeyTakeaways;